import { getDocument, GlobalWorkerOptions, type PDFDocumentProxy } from "pdfjs-dist";
import workerModuleUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

let workerConfigured = false;

function ensurePdfJsWorker(): void {
  if (workerConfigured || typeof window === "undefined") return;
  const workerSrc = workerModuleUrl.startsWith("http")
    ? workerModuleUrl
    : new URL(workerModuleUrl, window.location.origin).href;
  GlobalWorkerOptions.workerSrc = workerSrc;
  workerConfigured = true;
}

export async function loadPdfDocument(bytes: ArrayBuffer): Promise<PDFDocumentProxy> {
  ensurePdfJsWorker();
  const task = getDocument({ data: new Uint8Array(bytes) });
  return task.promise;
}

export async function loadPdfDocumentFromUrl(url: string): Promise<PDFDocumentProxy> {
  ensurePdfJsWorker();
  const task = getDocument(url);
  return task.promise;
}
